'use client';
// Клієнтський грід схожих ігор — перераховує ціни під обраний тип видачі + регіон
// (?offer=&region=) так само, як каталог/знижки: fetchPrices(offer, region) → priceUsdOverride.
// Читає offer/region з URL (їх пише OfferFilter у MoreLikeFilters). Лінк на PDP несе suffix.
import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { CatalogCard } from '@/components/catalog/CatalogCard';
import { readOfferParams } from '@/components/catalog/OfferFilter';
import { fetchPrices } from '@/lib/priceCache';
import type { CatalogIndexItem } from '@/types/catalog';

export function MoreLikeGrid({ items, lang }: { items: CatalogIndexItem[]; lang: string }) {
  const sp = useSearchParams();
  const { offerType, region } = readOfferParams(sp);
  const [priceMap, setPriceMap] = useState<Record<string, number>>({});

  useEffect(() => {
    if (region === 'any') { setPriceMap({}); return; }
    setPriceMap({});
    fetchPrices(offerType, region).then(setPriceMap);
  }, [offerType, region]);

  return (
    <div className="catalog-grid">
      {items.map(item => (
        <CatalogCard
          key={item.product_id}
          item={item}
          lang={lang}
          offerType={offerType}
          region={region}
          priceUsdOverride={region !== 'any' ? priceMap[item.product_id] : undefined}
        />
      ))}
    </div>
  );
}
